import axios from 'axios'
import router from '@/router';
import api from '@/api';
import { isArray } from 'chart.js/helpers';

function getShopAndProject(state) {
    const shop_code = router.currentRoute.value.query.shop_code;
    const shop = state.shops?.find(x => x.code == shop_code);
    if (!shop) return {};
    return { shop_code, project_code: shop.project_code };
}

export const сorporateOrdersListModule = {
    namespaced: true,

    state: () => ({
        shops: null,
        orders: null,
        suppliers: null,
        currentOrder: null,
        stateSearchQuery: '',
        products: null,
        pages: null,
        edited_succes: null,
    }),

    mutations: {
        setShops(state, data) {
            const shop_code = router.currentRoute.value.query.shop_code;
            data.forEach(shop => {
                shop.checked = Array.isArray(shop_code)
                    ? shop_code.includes(shop.id)
                    : shop.id == shop_code;
            });
            state.shops = data;
        },

        setOrders(state, data) {
            state.orders = data;
        },

        setCurrentOrder(state, data) {
            if (data.delivery_datetime_to) {
                data.delivery_date_to = data.delivery_datetime_to.split('T')[0];
                data.delivery_time_to = data.delivery_datetime_to.split('T')[1]?.substring(0, 5) || '';
                data.delivery_date_to_initial = data.delivery_date_to;
                data.delivery_time_to_initial = data.delivery_time_to;
            }
            // Сохраняем исходное значение скидки
            data.discount_amount_initial = data.discount_amount;
            data.additional_price_initital = data.additional_price
            data.prepayment_amount_initital = data.prepayment_amount
            data.items?.forEach(item => item.edited = false);
            state.currentOrder = data;
        },

        setSearchQuery(state, searchQuery) {
            state.stateSearchQuery = searchQuery;
        },

        setPages(state, data) {
            state.pages = data;
        },

        setEdited(state, bool) {
            state.edited_succes = bool;
        }
    },

    actions: {
        async getShops({ commit }) {
            try {
                const { data } = await axios.get(api + "projects/tcode/shops/", {
                    headers: { Authorization: 'Token ' + localStorage.getItem('token') }
                });
                data.forEach(shop => {
                    shop.label = shop.name;
                    shop.value = shop.id;
                });
                commit('setShops', data);
            } catch (error) {
                console.log(error);
            }
        },

        async getOrders({ state, rootState, commit }, isLoading) {
            if(isLoading) {
                rootState.isLoading = true;
            }
            const { shop_code, project_code } = getShopAndProject(state);
            if (!shop_code || !project_code) return;

            try {
                const { data } = await axios.get(
                    `${api}projects/${project_code}/shops/${shop_code}/personal/orders?${router.currentRoute.value.fullPath.split('?')[1]}`,
                    { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
                );
                commit('setOrders', data.results);
                commit('setPages', data.num_pages);
            } catch (error) {
                console.log(error);
            } finally {
                if(isLoading && rootState.isLoading) {
                    rootState.isLoading = false;
                }
            }
        },

        async getCurrentOrder({ state, commit }, id) {
            const { shop_code, project_code } = getShopAndProject(state);
            if (!shop_code || !project_code) return;

            try {
                const { data } = await axios.get(
                    `${api}projects/${project_code}/shops/${shop_code}/personal/orders/${id}`,
                    { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
                );
                commit('setCurrentOrder', data);
            } catch (error) {
                console.log(error);
            }
        },

        async changeOrderStatus({ state, dispatch }, data) {
            const { shop_code, project_code } = getShopAndProject(state);
            if (!shop_code || !project_code) return;

            try {
                const { data: resp } = await axios.get(
                    `${api}projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.id}/?status=${data.status}`,
                    { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
                );
                if (resp.success) {
                    dispatch('getOrders', true);
                    state.currentOrder = null;
                }
            } catch (error) {
                console.log(error.response);
            }
        },

        async sendInvoice({ state, dispatch }, data) {
            const { shop_code, project_code } = getShopAndProject(state);
            if (!shop_code || !project_code) return;

            try {
                await axios.get(
                    `${api}projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.id}?${data.type}=true`,
                    { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
                );
                dispatch('getOrders', true);
            } catch (error) {
                console.log(error);
            }
        },

        async orderDelete({ state, dispatch }, id) {
            const { shop_code, project_code } = getShopAndProject(state);
            if (!shop_code || !project_code) return;

            try {
                const { data } = await axios.get(
                    `${api}projects/${project_code}/shops/${shop_code}/personal/order-edit/${id}/?order_del=true`,
                    { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
                );
                if (data.success) {
                    state.currentOrder = null;
                    dispatch('getOrders', true);
                }
            } catch (error) {
                console.log(error);
            }
        },

        inputProductPrice({ state }, data) {
            const new_price = Number(data.event.target.value);
            if (data.old_price != new_price) {
                const item = state.currentOrder.items.find(x => x.id == data.id);
                item.product.price_float = new_price;
                item.price = new_price;
                item.edited = true;
            }
        },

        inputProductRatio({ state }, data) {
            const new_ratio = Number(data.event.target.value.replace(/,/g, "."));
            if (data.old_ratio != new_ratio) {
                const item = state.currentOrder.items.find(x => x.id == data.id);
                item.ratio = new_ratio;
                item.edited = true;
            }
        },

        inputProductCount({ state, dispatch }, data) {
            const new_quantity = Number(data.event.target.value);
            if(new_quantity == 0) {
                dispatch('orderProductDelete',{ order_id: state.currentOrder.id, item: data.item})
                return
            } 

            if (data.item.quantity != new_quantity) {
                const item = state.currentOrder.items.find(x => x.id == data.item.id);
                item.quantity = new_quantity * Number(item.product.multiplicity);
                item.sum_float = item.price_float * item.quantity;
                item.edited = true;
            }
        },

        async changeOrderProductEdit({ state }, data) {
            const { shop_code, project_code } = getShopAndProject(state);
            if (!shop_code || !project_code) return;

            return axios.post(
                `${api}projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.order.id}/`,
                { items: data.items },
                { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
            ).then(( response ) => {
                if(response.status == 200) {
                    if(response.data.success) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            })
        },

        async orderProductDelete({ state, rootState, dispatch }, data) {
            const { shop_code, project_code } = getShopAndProject(state);
            if (!shop_code || !project_code) return;

            rootState.isLoading = true;
            let url = `${api}projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.order_id}/?`;
            url += !data.item.is_cancelled ? `item_del=${data.item.id}` : `item_return=${data.item.id}`;

            try {
                const { data: resp } = await axios.get(url, {
                    headers: { Authorization: 'Token ' + localStorage.getItem('token') }
                });
                if (resp.success) {
                    dispatch('getCurrentOrder', data.order_id);
                    dispatch('getOrders', true);
                }
            } catch (error) {
                console.log(error.response);
            } finally {
                rootState.isLoading = false;
            }
        },

        async changeOrderProductPrice({ state }, data) {
            const { shop_code, project_code } = getShopAndProject(state);
            if (!shop_code || !project_code) return;

            try {
                await axios.get(
                    `${api}projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.order_id}/?item_edit=${data.item_id}&item_price=${data.item_price}`,
                    { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
                );
            } catch (error) {
                console.log(error.response);
            }
        },

        async changeOrderProductRatio({ state }, data) {
            const { shop_code, project_code } = getShopAndProject(state);
            if (!shop_code || !project_code) return;

            try {
                await axios.get(
                    `${api}projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.order_id}/?item_edit=${data.item_id}&item_ratio=${data.item_ratio}`,
                    { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
                );
            } catch (error) {
                console.log(error.response);
            }
        },

        async orderDownload({ state }, data) {
            const { shop_code, project_code } = getShopAndProject(state);
            if (!shop_code || !project_code) return;

            try {
                const response = await axios.get(
                    `${api}projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.id}/?export=${data.type}`,
                    {
                        headers: { Authorization: 'Token ' + localStorage.getItem('token') },
                        responseType: 'blob'
                    }
                );
                const url = URL.createObjectURL(response.data);
                const a = document.createElement('a');
                a.href = url;
                if (data.type == 'xlsx') {
                    a.download = `Заказ_№${data.id}.xls`;
                } else if (data.type == 'act') {
                    a.download = `Акт_заказа_${data.id}.doc`;
                } else if(data.type == 'prepayment_invoice'){
                    a.download = `Счет_на_предоплату_${data.id}.doc`;
                } else {
                    a.download = `Счет_на_оплату_${data.id}.doc`;
                }
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
            } catch (error) {
                console.log(error.response);
            }
        },

        async changeOrderComment({ state, dispatch }, data) {
            const { shop_code, project_code } = getShopAndProject(state);
            if (!shop_code || !project_code) return;

            try {
                await axios.post(
                    `${api}projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.id}/`,
                    { comment: data.comment },
                    { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
                );
                dispatch('getOrders', true);
            } catch (error) {
                console.log(error.response);
            }
        },

        async fetchProducts({ state, commit }, filters) {
            const { shop_code, project_code } = getShopAndProject(state);
            if (!shop_code || !project_code) return;

            let searchParam = '';
            if (filters.search && String(filters.search).trim() !== '') {
                searchParam = `&search=${encodeURIComponent(filters.search)}`;
            }

            return axios.get(
                `${api}projects/${project_code}/shops/${shop_code}/products?ordering=name&available=for_corporate&page=${filters.page}${searchParam}`,
                { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
            )
            .then((response) => {
                if(response.status == 200) {
                    return response.data
                }
            })
            
        },

        async addNewProduct({ state, dispatch }, data) {
            const { shop_code, project_code } = getShopAndProject(state);
            if (!shop_code || !project_code) return;

            try {
                const { data: resp } = await axios.get(
                    `${api}projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.order}?product_add=${data.product}`,
                    { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
                );
                if (resp.success) {
                    dispatch('getCurrentOrder', resp.order.id);
                    dispatch('getOrders', true);
                }
            } catch (error) {
                console.log(error.response);
            }
        },

        async saveOrderChanges({ state, dispatch }, data) {
            const { shop_code, project_code } = getShopAndProject(state);
            if (!shop_code || !project_code) return;

            const baseUrl = `${api}projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.id}`;
            
            const params = new URLSearchParams();

            if (Array.isArray(data.value)) {
                const key = data.item || 'table';

                if (data.value.length > 0) {
                    data.value.forEach(id => params.append(key, id));
                } else {
                    params.append(key, '');
                }
            } else {
                params.append(data.item, data.value);
            }

            axios
                .get(`${baseUrl}?${params.toString()}`, {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                .then((response) => {
                    if (response.status == 200) {
                        dispatch('getCurrentOrder', data.id);
                    }
                })
                .catch((error) => {
                    alert('Ошибка при сохранении');
                    console.log(error);
                });
        },

        async orderCounteragentActDownload({ state }, data) {
            const { shop_code, project_code } = getShopAndProject(state);
            if (!shop_code || !project_code) return;

            return axios
            .get(`${api}projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.order.id}/?export=act_reconciliation&date_from=${data.dateFrom}&date_to=${data.dateTo}`,
                {
                    headers: { Authorization: 'Token ' + localStorage.getItem('token') },
                    responseType: 'blob'
                })
                .then((response) => {
                    const url = URL.createObjectURL(response.data);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `Акт_сверки_${data.order.counteragent.name}_${data.dateFrom}-${data.dateTo}.doc`;
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    URL.revokeObjectURL(url);

                    return true
                })
                .catch((error) => {
                    console.log(error)
                    return false;
                });
        },
    }
}